//breakpoint considering the Medium breakpoint of bootstrap
//https://getbootstrap.com/docs/5.0/layout/breakpoints/
export const MOBILE_WINDOW_WIDTH_BREAKPOINT = 992
